<template>
    <div>
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header modal-header-color">
                                <h5 class="modal-title" id="footerCenterBtnsModalLabel">{{ t('APP.MODAL.SELECT') }}</h5>
                            </div>
                            <div class="modal-body modal-open modal-height-max">
                                <div class="row gutters">
                                    <div class="col-xl-12 col-lglg-12 col-md-12 col-sm-12 col-12">
                                        <div class="form-group">
                                            <input type="text" name="company" v-model="companySearch" id="company"
                                                   class="form-control mb-2"
                                                   placeholder="Digite o nome da companhia para buscar">
                                            <div class="justify-content-center modal-row2">
                                                <div v-for="company in filteredCompanies" :key="company.id">
                                                    <button class="btn btn-background mt-1"
                                                            @click="companyModalSelected(company.id)">
                                                        {{ company.text }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import {mapState} from 'vuex';
import {useI18n} from 'vue-i18n';
import {useToast} from 'vue-toastification';

export default {
    name: 'modalCompany',

    props: {
        companiesBackup: {
            type: Object,
        },
    },

    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast};
    },

    computed: {
        ...mapState({
            companies: 'companies',
        }),
        filteredCompanies() {
            const norm = s => (s || '')
                .toString()
                .trim()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase();

            const q = norm(this.companySearch);
            if (!q) return this.companies;

            return this.companies.filter(c => norm(c.text).includes(q));
        },
    },

    data() {
        return {
            companySearch: null,
        };
    },

    methods: {
        companyModalSelected(companyIdModal) {
            this.companyId = companyIdModal;
            localStorage.removeItem('companyId');
            this.companySelected = companyIdModal;
            this.$store.commit('showModalSelectCompany', false);
            localStorage.setItem('companyId', companyIdModal);
            this.$router.go();
        },
    },
};
</script>
